import { atom } from "recoil";

/**
 * The ID of the currently selected camera.
 * null means "use the first camera for the active region".
 * Session-only — home spot handles persistence across reloads.
 */
export const activeCameraIdAtom = atom<string | null>({
  key: "activeCameraId",
  default: null,
});
